// constants.js Prompt of the Day
export const navItems = [
     { name: "Home", path: "/" },
     { name: "Generate Image", path: "/ai-image-generator" },

     {
          name: "Gallery",
          path: "/gallery",
          children: [
               { name: "Prompt", path: "/gallery" },
               { name: "Gemini Prompts", path: "/category/google-gemini-prompts" },
               { name: "ChatGPT Prompts", path: "/category/chatgpt-prompts" },
               { name: "Midjourney Prompts", path: "/category/midjourney-prompts" },
               { name: "Stitch Prompts",  path: '/category/stitch-prompts',},
               { name: "Instagram Reel Prompts", path: "/instagram-reel-ai-prompts" },
               { name: "🌶 Spicy Prompt Library", path: "/18+" },
          ],
     },
     {
          name: "Categories",
          path: "#",
          children: [
               {
                    name: "🌶",
                    path: '/18+',
                    items: [
                         { name: "18+ Adult Prompt", url: "/18+" },
                         { name: "Comatozze Photo Prompts", url: "/comatozze-prompts-viral-ai-photo" },
                         { name: "comatozze Gemini Prompt", url: "/best-comatozze-gemini-prompt" },
                         { name: "Mia Khalifa Photo Prompts", url: "/mia-khalifa-ai-prompts" },
                         { name: "Midjourney Prompts Aesthetic", url: "/midjourney-prompts-aesthetic" },
                    ]
               },
               {
                    name: "✦",
                    path: 'category/google-gemini-prompts',
                    items: [
                         { name: "Bike Holi", url: "/bike-holi" },
                         { name: "Girls Holi", url: "/holi-prompt-for-girls" },
                         { name: "Saree Prompt", url: "/saree-prompt-for-gemini-girl-style" },
                         { name: "Shivaji Maharaj", url: "/shivaji-maharaj-prompt-for-gemini-ai" },
                         { name: "Sita Ramam", url: "/sita-ramam-prompt-for-gemini-ai" },
                         { name: "AI Hairstyle", url: "/gemini-ai-hairstyle-prompts-2026" },
                         { name: "Promise Day", url: "/promise-day-prompt-for-gemini-ai" },
                         { name: "Teddy Day", url: "/teddy-day-prompts-viral-ai" },
                         { name: "Gemini Viral Pop Art", url: "/viral-pop-art-prompt-for-gemini-ai-2026" },
                         { name: "Trending Neelothi Prompt", url: "/best-trending-neelothi-prompt-for-gemini-ai" },
                         { name: "Ghostface Prompts", url: "/ghostface-prompts-2026-viral-ai-image" },
                         { name: "Dhurandhar Prompts", url: "/akshaye-khanna-dhurandhar-entry-prompts" },
                         { name: "Snow Trend Prompt For Girls", url: "/gemini-ai-snow-girl-prompts-2025-kashmir-snow-queen" },
                         { name: "Winter Trend Prompt for Boy", url: "/gemini-winter-trend-prompt-for-boy-viral-winter-ai-photos" },
                         { name: "Kedarnath Temple Prompts", url: "/kedarnath-best-gemini-ai-kedarnath-temple-prompts" },
                         { name: "Stylish Boy and Girl Prompts", url: "/trending-prompt-perfect-gemini-ai-stylish-boy-girl-prompts" },
                         { name: "LinkedIn Profile Photo Prompts", url: "/linkedin-profile-photo-prompts" }
                    ]
               },

               {
                    name: "֎",
                    path: 'category/chatgpt-prompts',
                    items: [
                         { name: "DP Prompt", url: "/dp-prompt-chatgpt" },
                         { name: "ChatGPT Photo Editing Prompt", url: "/chatgpt-prompt-for-photo-editing" },
                         { name: "Viral Horse Photo Prompts", url: "/chatgpt-horse-photo-prompts" },
                         { name: "Daredevil Photo Prompt", url: "/daredevil-photo-prompt-for-chatgpt" },
                         { name: "Hairstyle Prompt Male Haircut Prompts", url: "/chatgpt-hairstyle-prompt-male" },
                         { name: "Free AI Image Generation Prompts", url: "/free-ai-prompts" },
                         { name: "Instagram Reels Editing Prompts", url: "/instagram-reel-ai-prompts" },
                         { name: "ChatGPT Photo Editing Prompts", url: "/chatgpt-photo-editing-prompts" },
                         { name: "50 ChatGPT Photo Editing Prompts", url: "/50-chatgpt-photo-editing-prompts" },
                         { name: "Best Avatar Prompts", url: "/ai-avatar-prompts" },
                         { name: "AI Logo Design Prompts", url: "/ai-logo-design-prompts" },
                         { name: "YouTube Thumbnail AI Prompts", url: "/youtube-thumbnail-ai-prompts" },
                         { name: "AI Trading, Crypto, forex Logo Prompts", url: "/ai-trading-logo-prompts" },
                         { name: "Real Estate AI Prompts for Property Descriptions Propts", url: "/real-estate-agents-prompts" },
                         { name: "Instagram Post Ai prompts", url: "/instagram-post-ai-prompts" },
                         { name: "ChatGPT Prompts for Money", url: "/chatgpt-prompts-for-money" },
                    ]
               },


          ],
     },

     {
          name: 'More',
          path: "/gallery",
          children: [
               { name: "About", path: "/about" },
               { name: "Blogs", path: "/blogs" },
               { name: "Pricing", path: "/pricing?subscription" },
               { name: "Marketplace", path: "/marketplace" },
               { name: "Support", path: "/support" },
               { name: "Contact Us", path: "/contact" },
               { name: "Privacy Policy", path: "/privacy-policy" },
          ],
     },
     {
          name: "Account",
          show: 'd-none',
          path: "/gallery",
          children: [
               { name: "Dashboard", path: "/account" },
               { name: "Profile", path: "/profile" },
          ],
     },
];


export const categoriesItes = [
     { label: "All", value: "all" },
     { label: "Art", value: "art" },
     { label: "Trending", value: "tranding" },
     { label: "Photography", value: "photography" },
     { label: "Portrait", value: "portrait" },
     { label: "Fashion", value: "fashion" },
     { label: "Cinematic", value: "cinematic" },
     { label: "Anime", value: "anime" },
     { label: "Fantasy", value: "fantasy" },
     { label: "Sci-Fi", value: "sci-fi" },
     { label: "Cyberpunk", value: "cyberpunk" },
     { label: "Abstract", value: "abstract" },
     { label: "Minimal", value: "minimal" },
     { label: "Colorful", value: "colorful" },
     { label: "Black & White", value: "bw" },
     { label: "Landscape", value: "landscape" },
     { label: "Nature", value: "nature" },
     { label: "Animals", value: "animals" },
     { label: "Architecture", value: "architecture" },
     { label: "Interior Design", value: "interior" },
     { label: "Product Design", value: "product" },
     { label: "Industrial", value: "industrial" },
     { label: "Vehicles", value: "vehicles" },
     { label: "Sports", value: "sports" },
     { label: "Gaming", value: "gaming" },
     { label: "Concept Art", value: "concept-art" },
     { label: "Illustration", value: "illustration" },
     { label: "Cartoons", value: "cartoons" },
     { label: "3D Render", value: "3d-render" },
     { label: "Isometric", value: "isometric" },
     { label: "Voxel", value: "voxel" },
     { label: "Pixel Art", value: "pixel-art" },
     { label: "Watercolor", value: "watercolor" },
     { label: "Oil Painting", value: "oil-painting" },
     { label: "Sketch", value: "sketch" },
     { label: "Poster", value: "poster" },
     { label: "UI/UX", value: "ui-ux" },
     { label: "Logos", value: "logos" },
     { label: "Typography", value: "typography" },
     { label: "Memes", value: "memes" },
     { label: "Historical", value: "historical" },
     { label: "Mythology", value: "mythology" }
];


export const promptCategories = [
     { label: "All", value: "all" },
     { value: "man", label: "Man" },
     { value: "woman", label: "Woman" },
     { value: "couple", label: "Couple" },
     { value: "kids", label: "Kids" },
     { value: "animal", label: "Animal" },
     { value: "portrait", label: "Portrait" },
     { value: "fashion", label: "Fashion" },
     { value: "cinematic", label: "Cinematic" },
     { value: "anime", label: "Anime" },
     { value: "fantasy", label: "Fantasy" },
     { value: "sci-fi", label: "Sci-Fi" },
     { value: "romance", label: "Romance" },
     { value: "nature", label: "Nature" },
     { value: "history", label: "Historical" },
     { value: "sports", label: "Sports" },
     { value: "action", label: "Action" },
     { value: "artistic", label: "Artistic" },
     { value: "commercial", label: "Commercial" },
     { value: "realism", label: "Realism" },
     { value: "surreal", label: "Surreal" },
     { value: "3d-render", label: "3D Render" },
     { value: "illustration", label: "Illustration" },
     { value: "watercolor", label: "Watercolor" },
     { value: "pixel-art", label: "Pixel Art" },
     { value: "safe", label: "Safe" },
     { value: "sensitive", label: "Sensitive" },
];
